import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/AcquireFooter';
import { SEOHead } from '../components/SEO/SEOHead';
export function TermsPage() {
  return <>
      <SEOHead title="Terms and Conditions - AcquireFlow" description="Read AcquireFlow's terms and conditions for using our automated MLS offer platform." canonical="https://acquireflow.com/terms-and-conditions" data-id="element-2821" />

      <div className="flex flex-col min-h-screen bg-gradient-to-b from-[#070707] via-[#0a0a0a] to-[#070707]" data-id="element-2822">
        <Navbar data-id="element-2823" />

        <main className="flex-grow" data-id="element-2824">
          {/* Hero Section */}
          <section className="relative w-full bg-gradient-to-b from-[#070707] via-[#0a0a0a] to-[#070707] py-20 px-6" data-id="element-2825">
            <div className="max-w-4xl mx-auto text-center" data-id="element-2826">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#3ab795]/10 border border-[#3ab795]/20 backdrop-blur-sm mb-6" data-id="element-2827">
                <div className="w-2 h-2 rounded-full bg-[#3ab795] animate-pulse" data-id="element-2828" />
                <p className="text-sm md:text-base font-medium text-[#3ab795] tracking-wide uppercase" data-id="element-2829">
                  Legal
                </p>
              </div>

              <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight tracking-tight mb-6" data-id="element-2830">
                Terms and Conditions
              </h1>

              <p className="text-lg text-[#b8bcc8]" data-id="element-2831">
                Last updated: January 2025
              </p>
            </div>
          </section>

          {/* Content Section */}
          <section className="relative w-full bg-gradient-to-b from-[#070707] via-[#0a0a0a] to-[#070707] py-20 px-6" data-id="element-2832">
            <div className="max-w-4xl mx-auto" data-id="element-2833">
              <div className="bg-gradient-to-br from-[#1a1a1a]/80 to-[#0f0f0f]/80 border border-white/10 rounded-2xl p-8 md:p-12 backdrop-blur-md" data-id="element-2834">
                <div className="prose prose-invert prose-lg max-w-none" data-id="element-2835">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2836">
                    1. Acceptance of Terms
                  </h2>
                  <p className="text-[#b8bcc8] mb-6" data-id="element-2837">
                    By accessing and using AcquireFlow ("Service"), you accept
                    and agree to be bound by the terms and provision of this
                    agreement. If you do not agree to these Terms and
                    Conditions, please do not use our Service.
                  </p>

                  <h2 className="text-2xl font-bold text-white mb-4 mt-8" data-id="element-2838">
                    2. Use License
                  </h2>
                  <p className="text-[#b8bcc8] mb-4" data-id="element-2839">
                    Permission is granted to temporarily access and use
                    AcquireFlow for personal, non-commercial transitory viewing
                    only. This is the grant of a license, not a transfer of
                    title, and under this license you may not:
                  </p>
                  <ul className="list-disc list-inside text-[#b8bcc8] mb-6 space-y-2" data-id="element-2840">
                    <li data-id="element-2841">Modify or copy the materials</li>
                    <li data-id="element-2842">
                      Use the materials for any commercial purpose or public
                      display
                    </li>
                    <li data-id="element-2843">
                      Attempt to reverse engineer any software contained on
                      AcquireFlow
                    </li>
                    <li data-id="element-2844">
                      Remove any copyright or proprietary notations from the
                      materials
                    </li>
                    <li data-id="element-2845">
                      Transfer the materials to another person or "mirror" the
                      materials on any other server
                    </li>
                  </ul>

                  <h2 className="text-2xl font-bold text-white mb-4 mt-8" data-id="element-2846">
                    3. Service Description
                  </h2>
                  <p className="text-[#b8bcc8] mb-6" data-id="element-2847">
                    AcquireFlow provides automated tools for real estate
                    investors to send offers on MLS properties. We reserve the
                    right to modify, suspend, or discontinue the Service at any
                    time without notice. We shall not be liable to you or any
                    third party for any modification, suspension, or
                    discontinuance of the Service.
                  </p>

                  <h2 className="text-2xl font-bold text-white mb-4 mt-8" data-id="element-2848">
                    4. User Accounts
                  </h2>
                  <p className="text-[#b8bcc8] mb-6" data-id="element-2849">
                    When you create an account with us, you must provide
                    accurate, complete, and current information. Failure to do
                    so constitutes a breach of the Terms. You are responsible
                    for safeguarding your account password and for any
                    activities or actions under your account.
                  </p>

                  <h2 className="text-2xl font-bold text-white mb-4 mt-8" data-id="element-2850">
                    5. Payment Terms
                  </h2>
                  <p className="text-[#b8bcc8] mb-6" data-id="element-2851">
                    Subscription fees are billed in advance on a monthly or
                    annual basis. All fees are non-refundable except as required
                    by law. We reserve the right to change our subscription fees
                    upon 30 days' notice.
                  </p>

                  <h2 className="text-2xl font-bold text-white mb-4 mt-8" data-id="element-2852">
                    6. Intellectual Property
                  </h2>
                  <p className="text-[#b8bcc8] mb-6" data-id="element-2853">
                    The Service and its original content, features, and
                    functionality are owned by AcquireFlow and are protected by
                    international copyright, trademark, patent, trade secret,
                    and other intellectual property laws.
                  </p>

                  <h2 className="text-2xl font-bold text-white mb-4 mt-8" data-id="element-2854">
                    7. Limitation of Liability
                  </h2>
                  <p className="text-[#b8bcc8] mb-6" data-id="element-2855">
                    In no event shall AcquireFlow, nor its directors, employees,
                    partners, agents, suppliers, or affiliates, be liable for
                    any indirect, incidental, special, consequential, or
                    punitive damages, including without limitation, loss of
                    profits, data, use, goodwill, or other intangible losses.
                  </p>

                  <h2 className="text-2xl font-bold text-white mb-4 mt-8" data-id="element-2856">
                    8. Governing Law
                  </h2>
                  <p className="text-[#b8bcc8] mb-6" data-id="element-2857">
                    These Terms shall be governed and construed in accordance
                    with the laws of the United States, without regard to its
                    conflict of law provisions.
                  </p>

                  <h2 className="text-2xl font-bold text-white mb-4 mt-8" data-id="element-2858">
                    9. Changes to Terms
                  </h2>
                  <p className="text-[#b8bcc8] mb-6" data-id="element-2859">
                    We reserve the right to modify or replace these Terms at any
                    time. If a revision is material, we will provide at least 30
                    days' notice prior to any new terms taking effect.
                  </p>

                  <h2 className="text-2xl font-bold text-white mb-4 mt-8" data-id="element-2860">
                    10. Contact Us
                  </h2>
                  <p className="text-[#b8bcc8] mb-2" data-id="element-2861">
                    If you have any questions about these Terms, please contact
                    us:
                  </p>
                  <ul className="list-none text-[#b8bcc8] space-y-2" data-id="element-2862">
                    <li data-id="element-2863">
                      <strong data-id="element-2864">ACQUIRE FLOW LLC</strong>
                    </li>
                    <li data-id="element-2865">254 Chapman Rd, Ste 208 #25827</li>
                    <li data-id="element-2866">Newark, Delaware 19702 US</li>
                    <li data-id="element-2867">
                      Email:{' '}
                      <a href="mailto:support@acquireflow.ai" className="text-[#3ab795] hover:text-[#2da07d]" data-id="element-2868">
                        support@acquireflow.ai
                      </a>
                    </li>
                    <li data-id="element-2869">
                      Phone:{' '}
                      <a href="tel:+18052090120" className="text-[#3ab795] hover:text-[#2da07d]" data-id="element-2870">
                        +1 805-209-0120
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Quick Links */}
              <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center" data-id="element-2871">
                <a href="/privacy-policy" className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white/10 border border-white/20 rounded-xl text-white font-medium hover:bg-white/20 transition-all duration-300" data-id="element-2872">
                  Privacy Policy
                </a>
                <a href="/contact" className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#3ab795] rounded-xl text-white font-medium hover:bg-[#2da07d] transition-all duration-300" data-id="element-2873">
                  Contact Us
                </a>
              </div>
            </div>
          </section>
        </main>

        <Footer data-id="element-2874" />
      </div>
    </>;
}